import { LocationStrategy } from '@angular/common';
import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  DetachedRouteHandle,
  RouteReuseStrategy,
} from '@angular/router';

@Injectable()
export class CustomReuseStrategy implements RouteReuseStrategy {
  back = false;
  handlers: { [key: string]: DetachedRouteHandle } = {};

  constructor(location: LocationStrategy) {
    location.onPopState(() => {
      this.back = true;
    });
  }

  retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle {
    if (!route.data['shouldReuse']) {
      return null || '';
    }
    return this.handlers[route.data['key']];
  }

  store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle): void {
    if (route.data['shouldReuse']) {
      this.handlers[route.data['key']] = handle;
    }
  }

  shouldDetach(route: ActivatedRouteSnapshot): boolean {
    if (route.data['shouldReuse'] == undefined) {
      return route.data['shouldReuse'] || false;
    } else {
      if (this.back) {
        this.back = false;
        if (!route.data['useEnter']) {
          this.handlers = {};
        }
        return route.data['shouldReuse'] || false;
      } else {
        if (!route.data['useEnter']) {
          this.handlers = {};
        }
        return route.data['shouldReuse'] || false;
      }
    }
  }

  shouldAttach(route: ActivatedRouteSnapshot): boolean {
    return !!route.data['shouldReuse'] && !!this.handlers[route.data['key']];
  }

  shouldReuseRoute(
    future: ActivatedRouteSnapshot,
    current: ActivatedRouteSnapshot
  ): boolean {
    return !!future.data['shouldReuse'];
  }
}

// import { LocationStrategy } from '@angular/common';
// import { Injectable } from '@angular/core';
// import {
//   ActivatedRouteSnapshot,
//   DetachedRouteHandle,
//   RouteReuseStrategy,
//   Router,
// } from '@angular/router';

// @Injectable()
// export class CustomReuseStrategy implements RouteReuseStrategy {
//   back = false;

//   handlers: { [key: string]: DetachedRouteHandle } = {};

//   constructor(private router: Router, location: LocationStrategy) {
//     location.onPopState(() => {
//       this.back = true;
//     });
//   }

//   retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle {
//     if (!route.data['shouldReuse']) {
//       return null || '';
//     } else {

//       return this.handlers[route.data['key']];
//     }
//   }

//   store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle): void {
//     if (route.data['shouldReuse']) {
//       this.handlers[route.data['key']] = handle;
//     }
//   }

//   shouldDetach(route: ActivatedRouteSnapshot): boolean {

//     if (this.back == true) {
//       return true;
//     } else {
//       return false;
//     }
//   }

//   shouldAttach(route: ActivatedRouteSnapshot): boolean {
//     return !!route.data['shouldReuse'] && !!this.handlers[route.data['key']];
//   }

//   shouldReuseRoute(future: any, current: any): boolean {
//     return !!future.data['shouldReuse'];
//   }
// }
